import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentSingleTabManager } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getRemoteConfig } from 'firebase/remote-config';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';

const configs = {
  production: {
    apiKey: "AIzaSyCGl3VrHB3MsXf9fzeR1nqz6vNymEyxzFw",
    authDomain: "gpt-debate.firebaseapp.com",
    projectId: "gpt-debate",
    storageBucket: "gpt-debate.firebasestorage.app",
    messagingSenderId: "229127441327",
    appId: "1:229127441327:web:b400ef048a8c8740837d5a",
    measurementId: "G-5SF5113BB2"
  },
  staging: {
    apiKey: "AIzaSyDSrdh-Q8jb6EE2nbQSmAIlknmwm_CKuuQ",
    authDomain: "gpt-debate-staging.firebaseapp.com",
    projectId: "gpt-debate-staging",
    storageBucket: "gpt-debate-staging.firebasestorage.app",
    messagingSenderId: "298417631866",
    appId: "1:298417631866:web:3bcb6dc4a58639b0fcc1c3",
    measurementId: "G-ES4V3MQ6SP"
  }
};

// Determine the environment
const getEnvironment = () => {
  // In development, default to staging unless specifically set to production
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_FIREBASE_ENV === 'production' ? 'production' : 'staging';
  }
  // In production build, use REACT_APP_FIREBASE_ENV to determine environment
  return process.env.REACT_APP_FIREBASE_ENV === 'staging' ? 'staging' : 'production';
};

const environment = getEnvironment();
const initialConfig = configs[environment];

// Initialize Firebase with the determined config
export const app = initializeApp(initialConfig);

// Initialize services
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentSingleTabManager()
  })
});
export const functions = getFunctions(app, 'us-central1');
export const remoteConfig = getRemoteConfig(app);
export const analytics = getAnalytics(app);

// Enable analytics collection based on environment
setAnalyticsCollectionEnabled(analytics);

// Inject gtag.js script for Google Analytics
const measurementId = initialConfig.measurementId;
if (measurementId) {
  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', measurementId);
}

// Configure auth persistence
auth.setPersistence(browserLocalPersistence).catch((err) => {
  console.warn('Auth persistence failed:', err);
});

